import axios from "axios";

export const downloadFile = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/export-csv`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Check if server sent an error message in blob (optional)
    if (response.data.size === 0) {
      alert("No data available to export.");
      return;
    }

    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "exported-products.csv";
    link.click();

    window.URL.revokeObjectURL(url);
    alert("✅ CSV downloaded successfully!");
  } catch (err) {
    console.error("Failed to download CSV", err);

    // Show user-friendly alert
    alert("Failed to download CSV. Please try again later.");
  }
};
